import React from 'react';
import { inject, observer } from 'mobx-react';
import { action } from 'mobx';
import { injectIntl } from 'react-intl';
import { withRouter, Link } from 'react-router-dom';
import { Col, Row, Panel } from 'react-bootstrap';

import Stages from '../common_components/bmc/Stages';
import Options from './Options';
import { BMC_BLOCKS, BMC_STAGES } from '../common_components/bmc/bmc_constants';
import { STARTUP_SECTIONS } from '../igmvp_components/models/constants';
import { BLOCKS_FOR_STARTUP_SECTION } from './ZonesResponsibilities';

import Filters from './Filters';
import Clone from './Clone';
import SaveButtonWithConfirmation from '../common_components/SaveButtonWithConfirmation';
import { INSTRUCTIONAL_ROUTES } from '../instructional_feed_components/constants';

@injectIntl
@withRouter
@inject('rootStore')
@observer
export default class BmcHeader extends React.Component {
  constructor(props) {
    super(props);

    this.state = {};

    this.canEdit = props.rootStore.authorizationStore.canEdit;
    this.canEditStage = props.rootStore.authorizationStore.canEditStage;
    this.canShowOptions = props.rootStore.authorizationStore.canShowOptions;
  }

  render() {
    const { rootStore, history, intl, modal } = this.props;

    return (
      <div style={{ paddingBottom: '15px' }}>
        {rootStore.showStages && !rootStore.oneBlockMode.active && (
          <div className="hidden-xs">
            <Stages
              current={rootStore.currentStage}
              secondaryCurrent={rootStore.secondaryCurrentStage}
              stagesMvp={rootStore.thinkingMode.getStageBmcs}
              atBmcVision={rootStore.thinkingMode.atBmcVision}
              onStageClick={rootStore.handleSelectStage}
              emphasizedSteps={rootStore.emphasizedSteps}
              canUnmarkStage={stage => rootStore.canUnmarkStage(stage)}
              onUnmarkStage={stage => rootStore.unmarkStage(stage)}
            />
          </div>
        )}
        <div id="bmc-header-btn-container">
          {this.renderSubHeaderTitle()}

          {this.canShowOptions && (
            <div
              style={{ marginRight: 10, marginTop: 10 }}
              className="bmc-filter-row"
            >
              <Options rootStore={rootStore} />
            </div>
          )}

          {this.canEdit && (
            <div
              style={{ marginRight: 10, marginTop: 10 }}
              className="bmc-step-by-step-row"
            >
              <Link
                to={`${history.location.pathname}/step_mode/${rootStore.stepByStepBlock}`}
                className="btn btn-primary"
                style={{ width: '125px' }}
                onClick={() => rootStore.handleStepByStep(true)}
              >
                {intl.formatMessage({ id: 'step_by_step' })}
              </Link>
            </div>
          )}

          {this.renderPerZoneLink()}
          {modal != undefined && this.renderFinishButton()}
        </div>

        {rootStore.showOptionsPanel && (
          <Panel style={{ marginTop: '25px' }} className="arrow-box">
            <Filters rootStore={rootStore} />

            {rootStore.belongsToCurrentMvp && this.canEdit && <Clone />}
          </Panel>
        )}
      </div>
    );
  }

  renderSubHeaderTitle = () => {
    const { rootStore, intl } = this.props;
    if (rootStore.thinkingMode.active) {
      const mvpName =
        rootStore.thinkingMode.stageBmcs[rootStore.secondaryCurrentStage]
          .mvpName;

      return (
        <div
          className="tool-sub-header"
          style={{ marginRight: 10, marginTop: 10 }}
        >
          {`${intl.formatMessage({
            id: rootStore.secondaryCurrentStage
          })} (${mvpName})`}
        </div>
      );
    }
  };

  renderPerZoneLink() {
    const {
      history: {
        location: { pathname }
      },
      intl,
      rootStore
    } = this.props;

    if (
      !(
        rootStore.belongsToCurrentMvp &&
        pathname.includes('dashboards/business')
      )
    ) {
      return null;
    }

    const newPathBase = pathname
      .replace(
        new RegExp(`/(${Object.values(STARTUP_SECTIONS).join('|')})`),
        ''
      )
      .replace('bmc_boards', `${STARTUP_SECTIONS.CUSTOMER_R}/bmc_boards`);

    return (
      <div
        style={{ marginRight: 10, marginTop: 10 }}
        className="bmc-step-by-step-row"
      >
        <Link
          to={`${newPathBase}/step_mode/${
            BLOCKS_FOR_STARTUP_SECTION[STARTUP_SECTIONS.CUSTOMER_R]
          }`}
          className="btn btn-primary"
          style={{ width: '125px' }}
        >
          {intl.formatMessage({ id: 'per_zone' })}
        </Link>
      </div>
    );
  }

  renderFinishButton = () => {
    const { intl } = this.props;

    return (
      <div
        style={{ marginRight: 10, marginTop: 10 }}
        className="bmc-step-by-step-row"
      >
        <SaveButtonWithConfirmation
          onConfirm={() =>
            (window.location = `${INSTRUCTIONAL_ROUTES.infrastructure(
              intl.locale
            )}`)
          }
        />
      </div>
    );
  };
}
